import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Set to 2 hours from now
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60 + 15 * 60 + 30); // 2h 15m 30s
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex flex-col items-center justify-center my-6" data-id="element-165">
      <p className="text-red-600 font-bold mb-2 text-sm uppercase tracking-wider animate-pulse" data-id="element-166">
        ⚠️ La oferta termina en:
      </p>
      <div className="flex gap-3" data-id="element-167">
        <div className="flex flex-col items-center" data-id="element-168">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-169">
            {hours.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-170">HORAS</span>
        </div>
        <div className="text-red-600 font-bold text-2xl mt-2" data-id="element-171">:</div>
        <div className="flex flex-col items-center" data-id="element-172">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-173">
            {minutes.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-174">MIN</span>
        </div>
        <div className="text-red-600 font-bold text-2xl mt-2" data-id="element-175">:</div>
        <div className="flex flex-col items-center" data-id="element-176">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-177">
            {seconds.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-178">SEG</span>
        </div>
      </div>
    </div>;
}